/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { createChatMessagePartDataRoleSchema } from './CreateChatMessagePartDataRoleSchema'

export const createChatMessagePartDataSchema = z.object({
	role: createChatMessagePartDataRoleSchema,
	id: z.string().nullable().optional(),
	parts: z.array(z.string()).nullable().optional(),
})

export type CreateChatMessagePartDataSchema = z.infer<typeof createChatMessagePartDataSchema>
